import http from '../const/http-common'

const login = (loginInfo) => {
  return http.post('/v1/auth/token', loginInfo);
}

const getUser = (token) => {
  const headers = {
    Authorization: `Bearer ${token}`,
    'ngrok-skip-browser-warning': true
  }
  return http.get('/v1/auth/verify-token', { headers });
}

const authService = {
  login,
  getUser
}

export default authService